// === FILE HEADER: Sound Constants Utility ===
// This file centralizes sound configuration, note sequences, and audio file paths for the Chess Slider SPA.
// Structure and section anchors follow project documentation and copilot-instructions.md.
// Last updated: 2025-07-15
//
// === END FILE HEADER ===
// === COPILOT FILE RULES ===
// DO NOT DELETE THE HEADER OR FILE RULES FROM THE FILE
// DO NOT PLACE ANY CODE, HOOKS, OR LOGIC ABOVE IMPORTS. 
// All import statements must be at the very top of the file, before any other code or comments (except for a file-level comment header or license block, if present).
// React hooks (useEffect, useState, etc.) must only be called inside a React function component or custom hook, never at the top level.
// Make a copy of the file in copies folder before doing any edits.
// Updating full large files has been difficult.  You may use the copy to refer to if it helps you.
// After completing edits compare the edited file to the original and make sure nothing other than the intended changes have happened
// If there are unintended changes repair the file
// After user approves the copy may be deleted
// DO NOT USE INLINE STYLES ALL STYLES MUST BE DEFINED IN THE PROPER FILE AND IMPORTED
// === END COPILOT FILE RULES ===
// === Section: Sound Constants ===
// Centralized sound configuration for note sequences and audio file paths.

// Note sequence strings for beep fallback (frequency:duration[+/-volumeAdj];)
export const NOTE_SEQUENCES = {
  moved: '150.00:0.5;', // average of old rank 6 color tile frequencies
  slide: '700.00:0.2;', // duration matches action (200ms)
  blocked: '600.00:0.5;', // test: mid-pitch, long duration
  victory: '523.00:0.2;'
};

// === Section: Tile Notes ===
// Each entry is a note string assigned to a tile in order
// Highest notes now assigned to rank 8, lowest to ranks 1/2, all durations set to 0.1s, each followed by a 0.05s pause
export const TILE_NOTES = [
  // Rank 8 (was rank 6)
  '4186.01:0.1;', '4434.92:0.1;', '4698.63:0.1;', '3951.07:0.1;', '3729.31:0.1;', '3520.00:0.1;', '3322.44:0.1;', '3135.96:0.1;',
  // Rank 7 (was rank 5)
  '2960.00:0.1;', '2793.83:0.1;', '2637.02:0.1;', '2489.02:0.1;', '2349.32:0.1;', '2217.46:0.1;', '2093.00:0.1;', '1975.53:0.1;',
  // Rank 6 (was rank 4)
  '1864.66:0.1;', '1760.00:0.1;', '1661.22:0.1;', '1567.98:0.1;', '1479.98:0.1;', '1396.91:0.1;', '1318.51:0.1;', '1244.51:0.1;',
  // Rank 5 (was rank 3)
  '1174.66:0.1;', '1108.73:0.1;', '1046.50:0.1;', '987.77:0.1;', '932.33:0.1;', '880.00:0.1;', '830.61:0.1;', '783.99:0.1;',
  // Rank 4 (was rank 2)
  '739.99:0.1;', '698.46:0.1;', '659.25:0.1;', '622.25:0.1;', '587.33:0.1;', '554.37:0.1;', '523.25:0.1;', '493.88:0.1;',
  // Rank 3 (was rank 1)
  '466.16:0.1;', '440.00:0.1;', '415.30:0.1;', '392.00:0.1;', '369.99:0.1;', '349.23:0.1;', '329.63:0.1;', '311.13:0.1;',
  // Rank 2 (new lower band)
  '293.66:0.1;', '277.18:0.1;', '261.63:0.1;', '246.94:0.1;', '233.08:0.1;', '220.00:0.1;', '207.65:0.1;', '196.00:0.1;',
  // Rank 1 (new lowest band)
  '185.00:0.1;', '174.61:0.1;', '164.81:0.1;', '155.56:0.1;', '146.83:0.1;', '138.59:0.1;', '130.81:0.1;', '123.47:0.1;'
];
// === End Section: Tile Notes ===

// Audio file paths for sound effects (optional, may not exist)
// The utility will check for file existence at runtime and fall back to note sequences if missing.
export const SOUND_FILES = {
  moved: '/src/assets/sounds/move.mp3',
  slide: '/src/assets/sounds/slide.mp3',
  blocked: '/src/assets/sounds/blocked.mp3',
  victory: '/src/assets/sounds/victory.mp3'
};
// === End Section: Sound Constants ===
